import React from "react";
import { FaMailBulk, FaLinkedin, FaGithub, FaInstagram } from "react-icons/fa";

const Footer = () => {
  const year = new Date();

  return (
    <>
      <footer
        className="w-full text-center p-6 bg-accent"
        style={{ backgroundColor: "#313131" }}
      >
        <div className="flex items-center justify-center mb-6">
          
          <a
            className="inline-block mx-2"
            href="https://www.linkedin.com/in/jenil-paladiya/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin className="text-2xl text-blue-400" />
          </a>
          <a
            className="inline-block mx-2"
            href="https://github.com/Jenilpaladiya/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub className="text-2xl text-black" />
          </a>
          <a
            className="inline-block mx-2"
            href="https://www.instagram.com/kanji.____/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram className="text-2xl text-pink-500" />
          </a>
          <a
            className="inline-block mx-2"
            href="mailto:jenilpaladiya15@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaMailBulk className="text-2xl text-blue-600" />
          </a>
        </div>
        <div className="hidden  md:flex items-center justify-center mb-6 flex-wrap">
          <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://www.fiverr.com/jenil191/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Fiverr
          </a>
          <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://www.upwork.com/freelancers/"
            target="_blank"
            rel="noopener noreferrer"
          >
            UpWork
          </a>
       
        
          <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://www.xing.com/profile/JenilArvindbhai_Paladiya"
            target="_blank"
            rel="noopener noreferrer"
          >
            xing
          </a>
          {/* <a
            className="text-xl inline-bloc mx-6 text-neutral"
            href="https://drive.google.com/file/d/1kjtaIVzhPJDm7QZBVpU0qAOLU8qWsNnk/view"
            target="_blank"
            rel="noopener noreferrer"
          >
            Resume
          </a> */}
        </div>

        <div className="w-full h-[2px] bg-gray-600"></div>
        <div className="flex flex-col md:flex-row items-center justify-between mt-4">
          <p>&copy; Copyright All Rights Reserved {year.getFullYear()}</p>
          <p>
            Developed by{" "}
            <a
              href="https://www.linkedin.com/in/jenil-paladiya/"
              className="text-primary hover:underline"
              target="blank"
            >
              Jenil Paladiya
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
